import { render } from "./DashboardSectionHeader.vue?vue&type=template&id=11e65159&scoped=true"
import script from "./DashboardSectionHeader.vue?vue&type=script&lang=js"
export * from "./DashboardSectionHeader.vue?vue&type=script&lang=js"

import "./DashboardSectionHeader.vue?vue&type=style&index=0&id=11e65159&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11e65159"]])

export default __exports__